import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { StockChart } from "angular-highcharts";

@Component({
  selector: "app-stockchart",
  templateUrl: "./stockchart.component.html",
  styleUrls: ["./stockchart.component.scss"],
})
export class StockchartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  stock: StockChart;
  yAxis: {
    lineColor: "var(--graph-text-color)";
    gridLineColor: "var(--gridline-color)";
    lineWidth: 0;
    endOnTick: false;
    labels: {
      style: {
        color: "var(--graph-text-color)";
        fontSize: "12";
      };
    };
    title: {
      style: {
        color: "var(--graph-text-color)";
        fontSize: "14";
      };
    };
  };
  constructor() {}

  ngOnInit() {
    if (!this.stock && this.data && this.data.length) {
      this.plotGraph(this.data);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data && this.data.length) {
      this.plotGraph(this.data);
    }
  }

  ngOnDestroy() {
    if (this.stock) {
      try {
        this.stock.destroy();
      } catch (e) {}
      this.stock = null;
    }
  }

  plotGraph(data) {
    if (this.stock) {
      try {
        this.stock.destroy();
      } catch (e) {}
      this.stock = null;
    }
    this.stock = new StockChart({
      chart: {
        reflow: true,
        type: "spline",
        style: {
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          color: "var(--primary-text-color)",
        },
        backgroundColor: "transparent",
      },
      time: {
        useUTC: false,
      },
      credits: {
        enabled: false,
      },
      rangeSelector: {
        selected: 5,
        enabled: false,
      },
      navigator: {
        enabled: true,
        height: 32,
        maskFill: "rgba(59, 130, 246, 0.12)",
        outlineColor: "#cbd5e1",
        series: {
          color: "#3b82f6",
          lineWidth: 1,
        },
      },
      title: {
        text: "",
      },
      xAxis: {
        lineColor: "#cbd5e1",
        lineWidth: 1,
        type: "datetime",
        labels: {
          style: {
            color: "#64748b",
            fontSize: "11px",
            fontWeight: "500",
          },
        },
      },
      yAxis: data[0].yaxis ? data[0].yaxis : this.yAxis,
      tooltip: {
        shared: true,
        split: false,
        useHTML: true,
        backgroundColor: "rgba(15, 23, 42, 0.94)",
        borderColor: "#334155",
        borderRadius: 8,
        padding: 10,
        shadow: {
          color: "rgba(0, 0, 0, 0.3)",
          offsetX: 0,
          offsetY: 6,
          opacity: 0.15,
          width: 12,
        },
        style: {
          color: "#f8fafc",
          fontSize: "12px",
        },
        headerFormat: '<div style="font-size:11px; font-weight:700; color:#94a3b8; margin-bottom:6px; letter-spacing:0.3px;">📅 {point.key}</div><table style="width:100%; border-collapse:collapse;">',
        pointFormat: '<tr><td style="color:{series.color}; padding:2px 10px 2px 0; font-size:12px;">● <span style="color:#cbd5e1; font-weight:500;">{series.name}:</span></td>' +
                     '<td style="text-align:right; font-weight:700; color:#ffffff; padding:2px 0 2px 8px;">{point.y:.2f} {series.userOptions.unit}</td></tr>',
        footerFormat: '</table>',
        xDateFormat: '%d-%m-%Y, %H:%M',
      },
      legend: {
        align: "center",
        enabled: true,
        verticalAlign: "bottom",
        layout: "horizontal",
        itemDistance: 18,
        itemStyle: {
          color: "#475569",
          fontWeight: "600",
          fontSize: "12px",
          cursor: "pointer",
        },
        itemHoverStyle: {
          color: "#0f172a",
        },
        y: 10,
      },
      plotOptions: {
        series: {
          turboThreshold: 50000,
          dataGrouping: {
            enabled: false,
          },
          states: {
            inactive: {
              opacity: 0.22,
            },
            hover: {
              lineWidthPlus: 1.5,
            },
          },
        },
      },
      series: data[0].series,
    });
  }
}
